function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFrance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 85.331 512 341.337",
    style: {
      enableBackground: "new 0 85.33 512 341.337"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 341.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#0052B4"
    },
    width: 170.663,
    height: 341.337
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    y: 85.331,
    style: {
      fill: "#D80027"
    },
    width: 170.663,
    height: 341.337
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFrance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "france.a7181dd4867dcad1ea5ff1c84ce67cfc.svg";